/**
 * industry_field_controller.js — reveal the Other text box on the Industry field (Stimulus).
 *
 * Element-scoped controller for templates/components/forms/industry_field.html,
 * used by Settings > Business Info and both business setup forms. The select
 * lists the trades plus Other; choosing Other shows a free-text box for an
 * industry not in the list, and choosing anything else hides it again. The
 * server renders the right initial state, so connect() only re-applies it.
 *
 * The hidden box keeps its text: IndustrySchema ignores industry_other unless
 * the select says Other, so a stale value is never stored.
 */

import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static targets = ["choice", "other"];
    static values = { other: String };

    connect() {
        this.toggle();
    }

    toggle(event) {
        const isOther = this.choiceTarget.value === this.otherValue;
        this.otherTarget.hidden = !isOther;
        if (isOther && event) this.otherTarget.focus();
    }
}
